(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const validateAllofixPriceRange = (range) => {
    const minimum = range.querySelector('[data-price-minimum]');
    const maximum = range.querySelector('[data-price-maximum]');
    const message = range.querySelector('[data-price-range-error]');
    if (!(minimum instanceof HTMLInputElement) || !(maximum instanceof HTMLInputElement)) return true;
    const invalid = minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber;
    maximum.setCustomValidity(invalid ? 'Le prix maximum doit être supérieur ou égal au prix minimum.' : '');
    if (message instanceof HTMLElement) message.hidden = !invalid;
    if (invalid) {
      const details = range.closest('details');
      if (details) details.open = true;
    }
    return !invalid;
  };
  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const range = event.target.closest('[data-price-range]');
    if (range) validateAllofixPriceRange(range);
  });
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const ranges = Array.from(event.target.querySelectorAll('[data-price-range]'));
    if (!ranges.map(validateAllofixPriceRange).every(Boolean)) {
      event.preventDefault();
      event.target.reportValidity();
    }
  });
  document.querySelectorAll('[data-price-range]').forEach(validateAllofixPriceRange);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-price-range]').forEach(validateAllofixPriceRange);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-application"]) return;
  try {
    
  const prepareApplicationValidation = () => {
    document.querySelectorAll('.allofix-application__form').forEach((form) => {
      form.addEventListener('invalid', (event) => {
        const details = event.target.closest('.allofix-application__optional');
        if (details) details.open = true;
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareApplicationValidation, { once: true });
  else prepareApplicationValidation();

  } catch(e) { console.error(e); }
})();
})();
